import * as React from 'react';
export const creditcooperatifSvg = React.forwardRef(
  function creditcooperatifSvgInner(props, ref) {
    return /*#__PURE__*/ React.createElement(
      'svg',
      {
        ...props,
        ref: ref,
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#D11242',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M23 10s-6.26 2.7-6.23 2.58C16.74 10.22 16 6 11.65 6 9 6.59 8.91 9 9.74 10.61a4.07 4.07 0 0 0 1.67 1.92A29.1 29.1 0 0 0 14 14s-5.91 6.94-6 12a8.34 8.34 0 0 1 1 0s3.26-4.13 5-6c.28 1.19 2.27 6.42 4 6 3.56-1.88 2.05-10.68 2-11 2.23-1.21 7-2 7-2s-3.78-3.18-4-3Z',
        fill: '#fff',
      }),
    );
  },
);
creditcooperatifSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var creditcooperatif = {
  category: 'brand',
  colorable: false,
  name: 'creditcooperatif',
  svg: creditcooperatifSvg,
};
